import { TolgeePlugin, FormatterMiddleware } from '@tolgee/core';
import { getAppProductName } from 'hooks/useTrans';
import { isNil } from 'lodash-es';

const createFormat = () => {
  const locales = new Map() as Map<string, string>;

  function isLocaleValid(locale: string) {
    try {
      return Boolean(Intl.NumberFormat.supportedLocalesOf(locale).length);
    } catch {
      return false;
    }
  }

  function getLocale(language: string) {
    if (!locales.get(language)) {
      let localeCandidate: string = String(language).replace(/[^a-zA-Z]/g, '-');
      while (!isLocaleValid(localeCandidate)) {
        localeCandidate = localeCandidate.split('-').slice(0, -1).join('-') || 'en';
      }
      locales.set(language, localeCandidate);
    }
    return locales.get(language);
  }

  const format: FormatterMiddleware['format'] = (props) => {
    const { translation, params } = props;

    if (isNil(params?.appProductName)) {
      return normalizeAppNames(translation);
    }
    return translation;
  };

  return Object.freeze({ getLocale, format });
};

const appProductName = getAppProductName();

function normalizeAppNames(str: string): string {
  str = str.replace(/{appProductName}/g, appProductName);
  return str;
}

export const AppNameFormat = (): TolgeePlugin => (tolgee, tools) => {
  tools.addFormatter(createFormat());
  return tolgee;
};
